import React from 'react';

import type {
	TownsquareAppHomeSlot,
	TownsquareAppSwitcherSlot,
	TownsquareTopNavStartSlots,
} from '@townsquare/nav-platform-integration/global-root';
import { AppSwitcherButton } from '@townsquare/navigation/switcher-button';
import { StatusRelayEnvironmentProvider } from '@townsquare/relay-utils/status-environment-provider';

import { useProductHomeDetails } from '../navigation/use-product-home-details';

const HomeAppHomeSlot: TownsquareAppHomeSlot = ({ AppHomeComponent, context }) => {
	const { Icon, name, href, label, onClick } = useProductHomeDetails();

	return (
		<AppHomeComponent
			appName={name}
			icon={Icon}
			href={href}
			label={label}
			onClick={onClick}
			queryRef={context.queryRef}
		/>
	);
};

const HomeAppSwitcherSlot: TownsquareAppSwitcherSlot = () => (
	<StatusRelayEnvironmentProvider>
		<AppSwitcherButton />
	</StatusRelayEnvironmentProvider>
);

export const HOME_TOP_NAV_START_SLOTS: TownsquareTopNavStartSlots = {
	AppSwitcherSlot: HomeAppSwitcherSlot,
	AppHomeSlot: HomeAppHomeSlot,
};
